import "../styles/ui_components/_disclosure-item.scss"

import { Controller } from "@hotwired/stimulus"
import { debounce } from "../helpers/utils"

export default class extends Controller<HTMLDetailsElement> {
  static targets = ["cta"]
  declare readonly ctaTarget: HTMLSpanElement

  static values = {
    ctaClose: String,
    ctaOpen: String,
  }
  declare readonly ctaCloseValue: string
  declare readonly ctaOpenValue: string

  connect(): void {
    this.ctaTarget.textContent = this.ctaOpenValue
    this.toggleCta()

    this.toggleCta = debounce(this.toggleCta.bind(this), 100)
  }

  toggle(): void {
    this.ctaTarget.textContent = this.element.hasAttribute("open")
      ? this.ctaOpenValue
      : this.ctaCloseValue
  }

  toggleCta(): void {
    const summary = this.element.firstElementChild
    const content = summary?.firstElementChild
    if (!content) return

    this.ctaTarget.toggleAttribute("hidden", content.scrollHeight === content.clientHeight)
  }
}
